import LocationBaseController from '../common/location.base.controller';
import AppConstants from '../../../config/app.constants';
import _ from 'lodash';

class LocationCreateController extends LocationBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, LocationService, Modal, $translate, IdStoreService,
		BranchService, CustomerService, NgMap, RouteService, ContractService, $q, $scope, UserBranchService, LocationBranchService, OrderViewService,
		Configs, SetupService, CommonLayoutService, DenominationService, DateUtil, BranchFundingSourceService, BranchFundingSourceOrderProfileService, CostCenterService, AtmMakesService) {
		// here _ = location
		super(Auth, $state, User, LocationService, Modal, $translate)

		this.isPMSuspended = (val) => {
			if (!val) return false;
			if (val && typeof val === 'object' && val.isSuspended !== undefined) {
				return val.isSuspended;
			}
			const id = (val && typeof val === 'object') ? val.Value : val;
			const pm = (this.pmSearchList || []).find(p => p.Value === id);
			return pm && pm.isSuspended;
		}

		this.NgMap = NgMap
		this.ContractService = ContractService
		this.BranchService = BranchService
		this.CustomerService = CustomerService
		this.RouteService = RouteService
		this.$scope = $scope;
		this.$q = $q
		this.User = User;
		this.LocationService = LocationService;
		this.IdStoreService = IdStoreService;
		this.UserBranchService = UserBranchService;
		this.LocationBranchService = LocationBranchService;
		this.DenominationService = DenominationService;
		this.Configs = Configs;
		this.totalCostomers = 0;
		this.totalContracts = 0;
		this.customer = []
		this.branch = []
		this.branches = []
		this.locations = []
		this.contracts = []
		this.contractDays = []
		this.costCenterList = [];
		this.locationZoneList = [];
		this.isValidDirective = true;
		this.isValidDenomination = true
		this.isValidMaxLoad = true;
		this.errorMessage = "";
		this.SetupService = SetupService;
		this.isAutoDetectOnFormSubmit = false;
		this.CommonLayoutService = CommonLayoutService;
		this.DateUtil = DateUtil;
		this.BranchFundingSourceService = BranchFundingSourceService;
		this.BranchFundingSourceOrderProfileService = BranchFundingSourceOrderProfileService;
		this.CostCenterService = CostCenterService;
		this.AtmMakesService = AtmMakesService;
		this.OrderViewService = OrderViewService;
		this.atmMakesList = [];
		this.locationSlots = [];
		this.denominations = [];
		this.showAddSlotForm = false;
		this.pickupRequestTimes = [];
		this.days = [{
			label: this.$translate.instant('location.mon'),
			value: 'Mon'
		},
		{
			label: this.$translate.instant('location.tues'),
			value: 'Tue'
		},
		{
			label: this.$translate.instant('location.wed'),
			value: 'Wed'
		},
		{
			label: this.$translate.instant('location.thurs'),
			value: 'Thu'
		},
		{
			label: this.$translate.instant('location.fri'),
			value: 'Fri'
		},
		{
			label: this.$translate.instant('location.sat'),
			value: 'Sat'
		},
		{
			label: this.$translate.instant('location.sun'),
			value: 'Sun'
		},
		{
			label: this.$translate.instant('location.hol'),
			value: 'Hol'
		},
		]

		this.lockTypes = CommonLayoutService.lockTypes();

		this.states = [
			{
				label: 'Alabama', value: 'AL'
			},
			{
				label: 'Alaska', value: 'AK'
			},
			{
				label: 'American Samoa', value: 'AS'
			},
			{
				label: 'Arizona', value: 'AZ'
			},
			{
				label: 'Arkansas', value: 'AR'
			},
			{
				label: 'California', value: 'CA'
			},
			{
				label: 'Colorado', value: 'CO'
			},
			{
				label: 'Connecticut', value: 'CT'
			},
			{
				label: 'Delaware', value: 'DE'
			},
			{
				label: 'District Of Columbia', value: 'DC'
			},
			// {
			// 	label: 'Federated States Of Micronesia', value: 'FM'
			// },
			{
				label: 'Florida', value: 'FL'
			},
			{
				label: 'Georgia', value: 'GA'
			},
			{
				label: 'Guam', value: 'GU'
			},
			{
				label: 'Hawaii', value: 'HI'
			},
			{
				label: 'Idaho', value: 'ID'
			},
			{
				label: 'Illinois', value: 'IL'
			},
			{
				label: 'Indiana', value: 'IN'
			},
			{
				label: 'Iowa', value: 'IA'
			},
			{
				label: 'Kansas', value: 'KS'
			},
			{
				label: 'Kentucky', value: 'KY'
			},
			{
				label: 'Louisiana', value: 'LA'
			},
			{
				label: 'Maine', value: 'ME'
			},
			{
				label: 'Marshall Islands', value: 'MH'
			},
			{
				label: 'Maryland', value: 'MD'
			},
			{
				label: 'Massachusetts', value: 'MA'
			},
			{
				label: 'Michigan', value: 'MI'
			},
			{
				label: 'Minnesota', value: 'MN'
			},
			{
				label: 'Mississippi', value: 'MS'
			},
			{
				label: 'Missouri', value: 'MO'
			},
			{
				label: 'Montana', value: 'MT'
			},
			{
				label: 'Nebraska', value: 'NE'
			},
			{
				label: 'Nevada', value: 'NV'
			},
			{
				label: 'New Hampshire', value: 'NH'
			},
			{
				label: 'New Jersey', value: 'NJ'
			},
			{
				label: 'New Mexico', value: 'NM'
			},
			{
				label: 'New York', value: 'NY'
			},
			{
				label: 'North Carolina', value: 'NC'
			},
			{
				label: 'North Dakota', value: 'ND'
			},
			{
				label: 'Northern Mariana Islands', value: 'MP'
			},
			{
				label: 'Ohio', value: 'OH'
			},
			{
				label: 'Oklahoma', value: 'OK'
			},
			{
				label: 'Oregon', value: 'OR'
			},
			{
				label: 'Palau', value: 'PW'
			},
			{
				label: 'Pennsylvania', value: 'PA'
			},
			{
				label: 'Puerto Rico', value: 'PR'
			},
			{
				label: 'Rhode Island', value: 'RI'
			},
			{
				label: 'South Carolina', value: 'SC'
			},
			{
				label: 'South Dakota', value: 'SD'
			},
			{
				label: 'Tennessee', value: 'TN'
			},
			{
				label: 'Texas', value: 'TX'
			},
			{
				label: 'Utah', value: 'UT'
			},
			{
				label: 'Vermont', value: 'VT'
			},
			{
				label: 'Virgin Islands', value: 'VI'
			},
			{
				label: 'Virginia', value: 'VA'
			},
			{
				label: 'Washington', value: 'WA'
			},
			{
				label: 'West Virginia', value: 'WV'
			},
			{
				label: 'Wisconsin', value: 'WI'
			},
			{
				label: 'Wyoming', value: 'WY'
			},
		]

		this.branchFilter = function (rec) {
			// debugger;
		}

		// this.sameForAll = false
		this.defBackoutTimes = false
		this._types = [{
			label: this.$translate.instant('location_types.DELIVERY'),
			value: 'DELIVERY'
		},
		{
			label: this.$translate.instant('routeControl.ATM'),
			value: 'ATM'
		},
		{
			label: this.$translate.instant('routeControl.nsng'),
			value: 'NO_SHIP_NO_GO'
		},
		{
			label: this.$translate.instant('routeControl.regular'),
			value: 'REGULAR'
		},
		{
			label: this.$translate.instant('routeControl.bank'),
			value: 'BANK'
		},
		{
			label: this.$translate.instant('routeControl.on_call'),
			value: 'ON_CALL'
		},
		{
			label: this.$translate.instant('routeControl.internal'),
			value: 'INTERNAL'
		},
		{
			label: this.$translate.instant('location_types.LOCKER'),
			value: 'LOCKER'
		},
		{
			label: this.$translate.instant('routeControl.truck'),
			value: 'TRUCK'
		},
		{
			label: this.$translate.instant('routeControl.tanker'),
			value: 'TANKER'
		},
		{
			label: this.$translate.instant('routeControl.carrier'),
			value: 'CARRIER'
		},
		{
			label: this.$translate.instant('routeControl.window'),
			value: 'WINDOW'
		},
		{
			label: this.$translate.instant('location_types.VAULT'),
			value: 'VAULT'
		}
		]

		this.day = {
			routeId: [],
			stops: [{
				label: 'Stop1',
				value: 'stop1'
			},
			{
				label: 'Stop2',
				value: 'stop2'
			}
			],
			options: [{
				label: 'Weekly',
				value: 'Weekly'
			},
			{
				label: 'Bi-Monthly',
				value: 'Bi_Monthly'
			},
			{
				label: 'Monthly',
				value: 'monthly'
			},
			{
				label: 'Seasonal',
				value: 'Seasonal'
			}
			]
		}

		// this.OTCCompanyNameList = [
		// 	{
		// 		label: 'First Premier',
		// 		value: 'FirstPremier'
		// 	},
		// 	{
		// 		label: 'VTS',
		// 		value: 'VTS'
		// 	},
		// {
		// 	label: 'DevCo',
		// 	value: 'DevCo'
		// },
		// {
		// 	label: 'Witzco',
		// 	value: 'witzco'
		// }
		// ]

		this.operationDays = [{
			label: this.$translate.instant('location.mon'),
			value: 'Mon'
		},
		{
			label: this.$translate.instant('location.tues'),
			value: 'Tue'
		},
		{
			label: this.$translate.instant('location.wed'),
			value: 'Wed'
		},
		{
			label: this.$translate.instant('location.thurs'),
			value: 'Thu'
		},
		{
			label: this.$translate.instant('location.fri'),
			value: 'Fri'
		},
		{
			label: this.$translate.instant('location.sat'),
			value: 'Sat'
		},
		{
			label: this.$translate.instant('location.sun'),
			value: 'Sun'
		},
		{
			label: this.$translate.instant('location.hol'),
			value: 'Holiday'
		}]

		this.dateFormat = 'MM/dd'
		this.today = moment.utc().format(),
			this._map = this._map.bind(this)
		this.onMarkerDragEnd = this.onMarkerDragEnd.bind(this)

		this.defaultModel = {
			id: null,
			location: '',
			status: true,
			customer: null,
			defaultBranch: null,
			loggedInUser: User.getUser().id,
			currentBranch: User.getUser().branchId,
			_address: '',
			_city: '',
			_state: null,
			_zip: '',
			refId: null,
			_poc: '',
			pocPhone: '',
			pocEmail: '',
			RNdeliveries: false,
			RNpickups: false,
			RNnoPickup: false,
			RNzeroPickup: false,
			individualBagout: false,
			centralBank: false,
			deliverBagOutPiece: false,
			balanceType: 'DENOMINATION',
			forecastingFlowDirection: 'EMPTY',
			flowThreshold: 0.2,
			Mon: {
				routeId: null,
				stops: null,
				options: null
			},
			Tue: {
				routeId: null,
				stops: null,
				options: null
			},
			Wed: {
				routeId: null,
				stops: null,
				options: null
			},
			Thu: {
				routeId: null,
				stops: null,
				options: null
			},
			Fri: {
				routeId: null,
				stops: null,
				options: null
			},
			Sat: {
				routeId: null,
				stops: null,
				options: null
			},
			Sun: {
				routeId: null,
				stops: null,
				options: null
			},
			Hol: {
				routeId: null,
				stops: null,
				options: null
			},
			seasonStart: null,
			seasonEnd: null,
			// startTime: null,
			// endTime: null,
			_type: null,
			keyId: '',
			maxDepositAmount: 0,
			// deliveryBackoutTimes: false,
			roundedDeposits: false,
			codAllow: false,
			allowMulti: false,
			bulkTransfer: false,
			deliveryLoc1: null,
			deliveryLoc2: null,
			deliveryLocCoin: null,
			deliveryLocCod: null,
			lastTransaction: true,
			_leave: true,
			verifyToTruck: true,
			verifyCoinToTruck: false,
			maxCassettes: null,
			atmCassette: false,
			packCoinSeparately: false,
			captureDenomStc: false,
			TRdeliveries: true,
			TRpickups: true,
			latitude: undefined,
			longitude: undefined,
			sameForAll: false,
			lockType: null,
			comments: null,
			OTCCompanyName: null,
			stopProcess: null,
			openTimeSun: null,
			closeTimeSun: null,
			openTimeMon: null,
			closeTimeMon: null,
			openTimeTue: null,
			closeTimeTue: null,
			openTimeWed: null,
			closeTimeWed: null,
			openTimeThu: null,
			closeTimeThu: null,
			openTimeFri: null,
			closeTimeFri: null,
			openTimeSat: null,
			closeTimeSat: null,
			openTimeHoliday: null,
			closeTimeHoliday: null,
			isSameOperationTime: false,
			ATMTransfer: false,
			OTCGeoFence: false,
			closeReq: false,
			closeEndOfStop: false,
			zoneRouting: false,
			stopPriority: null,
			model: null,
			serialNumber: null,
			secondaryLock: false,
			secondaryLockId: null,
			secondaryLockType: null,
			secondaryLockOTCCompanyName: null,
			secondaryLockCloseReq: false,
			secondaryLockAutoOpen: false,
			secondaryLockStaticOpenCode: null,
			enableOrderProfile: false,
			fundingSourceObj: {
				results: [],
				totalRecords: 0,
				loading: false,
				selectedFundingSource: null
			},
			orderProfileObj: {
				results: [],
				totalRecords: 0,
				loading: false,
				selectedOrderProfile: null
			},
			denominationSourceObj: {
				results: [],
				totalRecords: 0,
				loading: false,
				selectedDenomination: null
			},
			locationSlotDenominations: {
				results: [],
				totalRecords: 0,
			},
			handleAtmLikeRegular: false,
			handleAtmLikeRegularLocationType: ['ATM', 'LOCKER', 'DELIVERY', 'BANK', 'ON_CALL', "NO_SHIP_NO_GO"],
			idBatchImport: null,
			idBagoutExport: null,
			idBagoutDepositExport: null,
			idOTCLock: null,
			scheduledLocations: [],
			deleteScheduledLocationIds: [],
			selectedDenomination: [],
			routeListObj: {
				result: [],
				totalRecords: 0
			},
			NFCLock: false,
			NFCScan: false,
			NFCTagId: null,
			distanceFromBranch: null,
			travelTimeToBranch: null,
			isNonUSLocation: false,
			costCenter: null,
			selectedLocationZones: [],
			customerCostCenter: null,
			recurringStops: [],
			make: [],
			accountNumber: null,
			machineOwner: null,
			bankSourceId: null,
			FLMProvider: null,
			SLMProvider: null,
			optional1: null,
			optional2: null,
			optional3: null,
			bankWeek: null,
			frequencyOptions: null,
			dayOfWeekOptions: null,
			contractExpirationDate: null,
			forecastingStrategy: 'DISABLED',
			liabilityThreshold: null,
			securityThreshold: null,
			atmEmptyAtCalculationMethod: 'PERCENT_CHANGE',
			aecPercentChangeValue: '0.5%',
			aecPercentChangePeriodA: '30D',
			aecPercentChangePeriodB: '15D',
			aecWeightedAvgWeightA: 0.75,
			aecWeightedAvgPeriodA: '30D',
			aecWeightedAvgWeightB: 0.35,
			aecWeightedAvgPeriodB: '15D',
			aecSinglePeriod: '30D',
			addToSwapRatio: 'ALWAYS_ADD',
			deliveryCutOff: false,
			deliveryCutOffTime: null,
			lastRouteStop: false,
			targetStopTime: null,
			printDeliveryManifest: false,
			podReceipt: false,
			sendManifestOnDelivery: false,
			manifestRecipientEmail: '',
			zeroAmountPickupRecipientEmail: '',
			pickupSLA: false,
			pickupSLATime: null,
			autoRerouteMissed: false,
			packResidual: true,
			coinPermitted: false,
			bagoutEnabled: false,
			isTransferHoldLocation: false,
			monthlyCashCountLimit: false,
			monthlyCashCountLimitAmount: 0,
			fallbackFillRate: 0,
			singleBranch: null,
			preventativeMaintenanceId: null
		};
		this.custNotSelectError = false;
		this.locationType = ['TANKER', 'TRUCK', 'INTERNAL', 'WINDOW'];
		this.openTime = 'openTime';
		this.closeTime = 'closeTime';
		this.OTCCompanyNameList = [];
		this.dateOptions = {
			formatDayTitle: 'MMMM',
			maxMode: "day",
			// dateDisabled:
		};

		this.stopPriorityList = this.CommonLayoutService.priorityList();
		this.bankWeekList = this.CommonLayoutService.bankWeekList();
		this.frequencyList = this.CommonLayoutService.frequency();
		this.weekDayList = this.CommonLayoutService.dayOfWeek();
		this.foreCastingList = this.CommonLayoutService.forecastingMethod();
		this.atmEmptyAtCalculationMethodList = this.CommonLayoutService.atmEmptyAtCalculationMethod();
		// this.loadLocationId();

		this.passWdIcon = {};
		this.passwordStats = ['primary', 'secondary'];
		this.customerCostCenterObj = {
			results: [],
			total: 0
		}
		this.combinedRouteIntervals = this.CommonLayoutService.combinedRouteIntervals();
		this.combinedRoutes = [];
		this.dayMap = this.CommonLayoutService.dayMap();
		this.locationRecurringLoad = [];
		this.isValidRecurringLoad = true;
		this.addToSwapRatioOptions = [
			{
				label: 'Always Add',
				value: 'ALWAYS_ADD'
			},
			{
				label: 'Always Swap',
				value: 'ALWAYS_SWAP'
			},
			{
				label: '2 Adds Between Swap',
				value: '2_ADDS_BETWEEN_SWAP'
			},
			{
				label: '3 Adds Between Swap',
				value: '3_ADDS_BETWEEN_SWAP'
			},
			{
				label: '4 Adds Between Swap',
				value: '4_ADDS_BETWEEN_SWAP'
			},
			{
				label: '5 Adds Between Swap',
				value: '5_ADDS_BETWEEN_SWAP'
			},
			{
				label: '6 Adds Between Swap',
				value: '6_ADDS_BETWEEN_SWAP'
			}
		]
		this.balanceTypes = [
			{ label: 'Denomination', value: 'DENOMINATION' },
			{ label: 'Percentage', value: 'PERCENTAGE' },
		];
		this.forecastingFlowDirection = [
			{ label: 'Fill', value: 'FILL' },
			{ label: 'Empty', value: 'EMPTY' },
		];
		this.manifestTypeList = [
			{
				value: 'bin_manifest_transport', label: 'Bin Manifest Transport'
			},
			{
				value: 'bagout_manifest', label: 'Bagout Manifest'
			},
			{
				value: 'delivery_manifest', label: 'Delivery Manifest'
			}
		];
		this.manifestFileType = [
			{ value: 'EXCEL', label: 'EXCEL' },
			{ value: 'PDF', label: 'PDF' }
		];
	}

	_map($event) {
		this.model.latitude = $event.latLng.lat()
		this.model.longitude = $event.latLng.lng()
		if (this.model.latitude, this.model.longitude) {
			this.getAddressFromLatLng(this.model.latitude, this.model.longitude)
		}
	}

	loadPreventativeMaintenances(searchKey, offset) {
		searchKey = searchKey || '';
		return this.Service.getPreventativeMaintenanceList(10, offset, searchKey)
			.then((data) => {
				const pmList = (data.results || []).map(pm => ({
					Key: pm.title + (pm.status === 'Suspended' ? ' (suspended)' : ''),
					Value: pm.id,
					isSuspended: pm.status === 'Suspended'
				}));
				if (offset === 0 || offset === undefined) {
					this.totalPMRecords = data.total || 0;
					this.pmSearchList = pmList;
				} else {
					this.pmSearchList = this.pmSearchList.concat(pmList);
				}
			});
	}

	loadRoutes(searchKey, offset) {
		let selectedBranch = Array.isArray(this.model.branch) ? this.model.branch.map((branch) => branch.branchId) : this.model.currentBranch.split();
		searchKey = searchKey || '';
		const routeSearchObj = {
			queryJSON: {
				rules: [{
					field: 'branchId',
					condition: 'IN',
					data: selectedBranch
				},
				{
					field: 'holdRoute',
					condition: '=',
					data: false
				},
				{
					field: 'active',
					condition: '=',
					data: true
				},
				{
					group: {
						rules: [{
							field: 'id',
							condition: 'like',
							data: '%' + searchKey + '%'
						},
						{
							field: 'name',
							condition: 'like',
							data: '%' + searchKey + '%'
						}
						],
						operator: 'OR'
					}
				}
				],
				operator: 'AND'
			}
		};

		return this.RouteService.all(routeSearchObj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.totalRoutes = data.total;
					this.day.routeId = this.mapRoutes(data.results);
				} else {
					const routeId = this.mapRoutes(data.results);
					this.day.routeId = this.day.routeId.concat(routeId);
				}
			});
	}

	mapRoutes(mapArray) {
		return mapArray.map((obj) => {
			return {
				Key: obj.name + ' (' + obj.shortName + ')',
				Value: obj.id
			}
		});
	}

	isDisabledDate = function (currentDate) {
		// if (this.model.seasonStart > this.model.seasonEnd) {
		// 	// this.model.seasonEnd = this.model.seasonStart;
		// 	this.today = moment.utc(currentDate).format()
		// } else {
		// 	this.today = moment.utc().format()
		// }
		this.todayMinDate = {
			minDate: this.model.seasonStart,
			formatDayTitle: 'MMMM',
			maxMode: "day"
		}
	}

	// do not allow to paste string into textbox
	dontAllow(element) {
		element.on('cut copy paste', function (event) {
			event.preventDefault();
		});
	}

	isUTC() {
		this.x = moment(this.model.seasonEnd).format('Y-MM-DD');
		this.expDate = `${this.x}T23:59:59.000Z`;
		this.model.seasonEnd = this.expDate
	}

	searchPaginate(searchKey, idKey, nameKey) {
		return {
			queryJSON: {
				rules: [{
					field: idKey,
					condition: 'like',
					data: '%' + searchKey + '%'
				},
				{
					field: nameKey,
					condition: 'like',
					data: '%' + searchKey + '%'
				}
				],
				operator: 'OR'
			}
		}
	}

	customerSearchObj(searchKey) {
		return {
			queryJSON: {
				rules: [
					{
						field: "isEnabled",
						condition: "=",
						data: true
					},
					{
						group: {
							rules: [
								{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "name",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					}
				],
				operator: "AND"
			}
		}
	}

	loadCustomer(searchKey, offset) {
		searchKey = searchKey || '';
		let costomerSearchObj = this.customerSearchObj(searchKey);
		return this.CustomerService.all(costomerSearchObj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.totalCostomers = data.total;
					this.customer = this.mapCustomerData(data.results);
				} else {
					const customer = this.mapCustomerData(data.results);
					this.customer = this.customer.concat(customer);
				}
			});
	}

	mapCustomerData(mapArray) {
		return mapArray.map((obj) => {
			return {
				Key: obj.id + ' | ' + obj.name,
				Value: obj.id
			}
		});
	}

	loadCostCenter(searchKey, offset) {
		searchKey = searchKey || '';

		const obj = {
			queryJSON: {
				rules: [
					{
						field: "customerFlag",
						condition: "=",
						data: false
					},
					{
						group: {
							rules: [
								{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "name",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					}
				],
				operator: "AND"
			}
		}

		return this.CostCenterService.all(obj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.totalCostCenter = data.total;
					this.costCenterList = this.mapCustomerData(data.results);
				} else {
					const costCenter = this.mapCustomerData(data.results);
					this.costCenterList = this.costCenterList.concat(costCenter);
				}
			});
	}

	loadCustomersCostCenter(searchKey, offset) {
		searchKey = searchKey || '';

		const obj = {
			queryJSON: {
				rules: [
					{
						field: "customerFlag",
						condition: "=",
						data: true
					},
					{
						group: {
							rules: [
								{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "name",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					}
				],
				operator: "AND"
			}
		}

		return this.CostCenterService.all(obj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.customerCostCenterObj.total = data.total;
					this.customerCostCenterObj.results = this.mapCustomerData(data.results);
				} else {
					const costCenter = this.mapCustomerData(data.results);
					this.customerCostCenterObj.results = this.customerCostCenterObj.results.concat(costCenter);
				}
			});
	}

	loadLocationZone(searchKey, offset) {
		this.totalLocationZone = 0;
		this.locationZoneList = [];
		return this.$q.resolve();
	}

	// loadContract(searchKey, offset) {
	// 	searchKey = searchKey || '';
	// 	let contractSearchObj = this.searchPaginate(searchKey, 'contractId', 'contractName')
	// 	return this.ContractService.all(contractSearchObj, offset, AppConstants.defaultPageLimit)
	// 		.then((data) => {
	// 			if (offset === 0 || offset == undefined) {
	// 				this.totalContracts = data.total;
	// 				this.contracts = this.mapContractsData(data.results);
	// 			} else {
	// 				const contracts = this.mapContractsData(data.results);
	// 				this.contracts = this.contracts.concat(contracts);
	// 			}
	// 		});
	// }

	// mapContractsData(mapArray) {
	// 	return mapArray.map((obj) => {
	// 		return {
	// 			Key: obj.contractId + ' | ' + obj.contractName,
	// 			Value: obj.id
	// 		}
	// 	});
	// }

	$onInit() {
		this.isValid = true;
		this.isValidRecurringStops = true;
		this.intervalList = this.CommonLayoutService.intervalList();

		this.passwordStats.forEach((stat) => {
			this.passWdIcon[stat] = { viewStaticOpenCode: false };
		})

		if (this.model && this.model.id && this.model.refId && this.model.id == this.model.refId) {
			this.defaultModel.id = this.nextAvailableId = this.model.refId
		}
		this.model = Object.assign(this.defaultModel, this.model || {})
		this.model = angular.copy(this.defaultModel);
		// this.model.OTCCompanyName = this.OTCCompanyNameList[0].value;
		this.model.defaultBranch = this.User.getUser().branchId;

		this.loading = true;
		if (!this.nextAvailableId) {
			this.loadLocationId();
		}
		this.loadAtmMakes();

		this.startMaxDate = {
			minDate: moment().startOf('day').format('YYYY-MM-DD 00:00:00')
		}

		this.$q.all([
			this.loadUsersBranch(),
			// this.loadContract('', 0),
			this.loadCustomer('', 0),
			this.loadRoutes('', 0),
			this.loadCostCenter('', 0),
			this.loadCustomersCostCenter('', 0),
			this.loadLocationZone('', 0),
			this.getAllFundingSource('', 0),
			this.loadConfigs(),
			this.createCombinedRoutes(),
			this.getAllDenominations('', 0),
			this.getAllLocationSlotDenominations('', 0),
			this.loadPickupRequestTimes(),
			this.loadPreventativeMaintenances('', 0)
		])
			.then((data) => {
				// this.branch = data[0].results
			})
			.finally(() => {
				this.loading = false;
			})
			.catch((err) => {
				console.log(err);
			});

		this.$scope.$watch(() => this.model.coinPermitted, (newVal, oldVal) => {
			if (this.model._type === 'ATM' && this.model.bankSourceId &&
				this.model.denominationSourceObj && this.model.denominationSourceObj.results &&
				this.model.denominationSourceObj.results.length > 0 && newVal !== oldVal) {
				this.getFilteredDenominations();
			}
		});
	}

	loadBranchData() {
		if (!this.model.branch.length) {
			this.days.map((day) => {
				this.model[day.value].routeId = null;
			})
		}
		this.model.selectedLocationZones = [];
		setTimeout(() => {
			this.loadRoutes('', 0);
			this.routeList('', 0);
			this.loadLocationZone('', 0);
			this.$scope.$digest();
		}, 1000)
	}

	// Display next availableId on branch change
	loadLocationId() {
		this.previewNextAvailableId();
	}

	// Display next available ID for location
	previewNextAvailableId() {
		this.branchId = this.IdStoreService.branchIdPrefix(this.model.defaultBranch)
		this.IdStoreService.getPreviewNextId(this.branchId, 1)
			.then((data) => {
				this.nextAvailableId = data.start;
			})
			.catch((err) => {
				this.nextAvailableId = "";
				console.log(err);
			});
	}

	changeCustomer() {
		if (this.model.customer) {
			if (this.model.sameForAll) {
				this.custNotSelectError = false;
				// this.clearContractDays();
			}
			this.CustomerService.get(this.model.customer.Value)
				.then((data) => {
					// this.loadDays(data);
					if (this.model.sameForAll) this.clearContractDays();
				})
		}
		else {
			if (this.model.sameForAll) {
				this.uncheckSameForAll();
				this.clearContractDays();
			}
		}
	}

	clearContractDays() {
		for (let day in this.contractDays) {
			if (this.contractDays[day]) {
				for (let key in this.model[day]) {
					this.model[day][key] = ''
				}
			}
		}
		// this.contractDays = []
	}

	createCombinedRoutes() {
		this.combinedRoutes = [];
		this.days.forEach(day => {
			this.combinedRoutes.push({
				sequence: 99,
				day: day,
				route: null,
				interval: null,
				anchorDate: null,
				combinedRouteIntervals: [...this.combinedRouteIntervals],
				isVisible: day.value === 'Hol' ? false : true
			})
		})
	}

	sameAll() {
		this.contractDays = [];
		this.days.forEach((data) => {
			this.contractDays[data.value] = true;
		})

		if (this.model.sameForAll) {
			for (let day in this.contractDays) {
				if (this.contractDays[day]) {
					for (let key in this.model[day]) {
						this.model[day][key] = ''
					}
				}
			}
		}
	}

	updateAll(selectedDay, opt) {
		if (this.model.sameForAll) {
			if (this.contractDays[selectedDay]) {
				for (let day in this.contractDays) {
					if (this.contractDays[day]) {
						this.model[day][opt] = this.model[selectedDay][opt];
					}
				}
			}
		}
	}

	uncheckSameForAll() {
		this.custNotSelectError = true;
		setTimeout(() => {
			this.custNotSelectError = false;
			this.model.sameForAll = false;
			this.$scope.$digest();
		}, 4000);
	}

	changeLocationType() {
		this.model.centralBank = false;
		this.model.verifyToTruck = ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf(this.model._type) > -1;
		// this.model.verifyCoinToTruck = this.model.verifyToTruck;

		if (this.model._type !== 'ATM') {
			this.model.maxCassettes = null;
		}

		if (this.model._type == 'WINDOW' || this.model._type == 'INTERNAL' || this.model._type == 'TANKER') {
			let anyOne;
			this.branch.forEach((d, index) => {
				if (anyOne == null && d.ticked) {
					anyOne = d;
				} else {
					d.ticked = false;
				}
			});
			if (anyOne) {
				this.model.singleBranch = anyOne.branchId;
				this.model.branch = [anyOne];
			} else {
				this.model.singleBranch = null;
				this.model.branch = [];
			}
			this.loadLocationZone('', 0);
		}
		if (this.model._type !== 'ATM' && this.model._type !== 'LOCKER') {
			this.model.lockType = null;
			this.model.OTCCompanyName = null;
		}
		// else this.model.OTCCompanyName = this.OTCCompanyNameList[0].value;
		this.showStopProcess = ['TANKER', 'TRUCK', 'WINDOW', 'CARRIER', 'LOCKER'].indexOf(this.model._type) === -1;
		if (!this.showStopProcess) this.model.stopProcess = null;
		this.createLocationRecurringLoad();
	}

	onAtmCassetteChange() {
		if (!this.model.atmCassette) {
			this.model.maxCassettes = null;
		}
	}

	// Reset Multi-Branch selection
	resetMultiBranchSelection() {
		if (this.model.branch && this.model.branch.length) {
			this.model.branch.forEach((selectedBranch) => {
				this.branch.filter((branch) => {
					if (branch.branchId == selectedBranch.branchId) {
						branch.ticked = false;
					}
				})
			})
		}
		this.loadUsersBranch()
	}

	onSingleBranchChange() {
		this.branch.forEach(b => {
			b.ticked = (b.branchId === this.model.singleBranch);
		});
		this.model.branch = this.branch.filter(b => b.ticked);
		this.loadBranchData();
	}

	// Load branch user has permission
	loadUsersBranch() {
		this.UserBranchService.getUserBranches(this.model.loggedInUser)
			.then((data) => {
				this.branch = data.results;
				this.branch.filter((branch) => {
					if (branch.branchId == this.model.defaultBranch) {
						branch.ticked = true;
					}
				})
				if (this.model._type == 'WINDOW' || this.model._type == 'INTERNAL' || this.model._type == 'TANKER') {
					this.model.singleBranch = this.model.defaultBranch;
					this.model.branch = this.branch.filter(b => b.ticked);
					this.loadLocationZone('', 0);
				}
				this.getSetupDetails();
				// this.model.OTCCompanyName = this.OTCCompanyNameList[0].value;
			}).catch((err) => {
				console.log(err);
			});
	}

	calculateCoinAmount(recurringLoad, denom) {
		if (recurringLoad.qty) {
			if (denom.faceValue) {
				recurringLoad.amount = recurringLoad.qty * denom.faceValue;
			}
		}
	}

	reset() {
		this.resetMultiBranchSelection();
		this.model = angular.copy(this.defaultModel);
		this.getAllDenominations()
		this.getAllLocationSlotDenominations()
		this.nextAvailableId = "";
		this.errorMessage = "";
		this.day.routeId = [];
		this.totalRoutes = 0;
		this.clearErrors();
		angular.element("input[type='time']").val(null) // reset Delivery-Backout-time toggle Data on switch-off
		this.previewNextAvailableId();
		this.resetCombinedRoutes();
		this.locationRecurringLoad = [];
	}

	// create branch group for location
	createLocationBranch() {
		this.branches = this.model.branch.map((branchObj) => branchObj.branchId)
		this.LocationBranchService.createLocationBranchGroup({
			locationId: this.nextAvailableId,
			branches: this.branches
		})
			.then((res) => {

			})
			.catch((err) => {
				console.log(err)
			});
	}

	submit(evt) {
		let promise = Promise.resolve();
		this.isAutoDetectOnFormSubmit = true;
		promise = promise
			// .then(() => this.autoDetect())
			.then(() => {
				this.loading = true;
				if (this.model.deliveryToLocation && this.model.deliveryToLocation.length) {
					this.model.deliveryToLocation.map((deliveryLocObj, index) => {
						if (deliveryLocObj.allLocations) {
							delete (this.model.deliveryToLocation[index].allLocations)
						}
						if (deliveryLocObj.allShipeType) {
							delete (this.model.deliveryToLocation[index].allShipeType)
						}
					})
				}

				if (this.model.scheduledLocations.length) {
					this.model.scheduledLocations.forEach((d) => {
						d.vaultDate = moment(d.vaultDate).format('YYYY-MM-DD')
						d.routeId = d.routeId.Value
					})
				}

				// Validate user-entered maxLoad is divisible by denomination faceValue
				this.checkForMaxLoadFaceValueDivisibility();
				if(this.model.selectedDenomination.length){
					this.model.selectedDenomination.forEach((i)=>{
						i.maxLoad = i.maxLoad,
							i.maxResidualThreshold = this.convertStr(i.maxResidualThreshold),
							i.minResidualThreshold = this.convertStr(i.minResidualThreshold)
						i.id = i.denom.id// denominationId
					})
				}

				// if (this.model.recurringStops.length && ['TRUCK', 'INTERNAL', 'TANKER', 'WINDOW', 'CARRIER'].indexOf(this.model._type) === -1) {
				// const recurringStops = [];
				// this.model.recurringStops.forEach((d) => {
				// 	d.anchorDate = moment(d.anchorDate).format('YYYY-MM-DD');
				// 	d.effectiveTillDate = d.effectiveTillDate ? moment(d.effectiveTillDate).format('YYYY-MM-DD') : null;
				// 	d.routeId = d.route.Value;
				// 	d.locationId = this.nextAvailableId;
				// 	delete d.route;
				// 	recurringStops.push(_.cloneDeep(d));
				// })

				const combinedRoutes = [];
				this.combinedRoutes.forEach((r) => {
					if (r.route && r.sequence && r.anchorDate && r.interval) {
						combinedRoutes.push({
							anchorDate: moment(r.anchorDate).format('YYYY-MM-DD'),
							effectiveTillDate: null,
							frequency: r.interval.frequency,
							sequence: r.sequence,
							interval: r.interval.interval,
							routeId: r.route.Value,
							locationId: `${this.nextAvailableId}`,
							description: `${r.day.value} ${this.nextAvailableId} CombinedRoute`,
							dayOfWeek: r.day.value,
							locationScheduleRecurringLoadData: this.locationRecurringLoad.flatMap(d =>
								d.locationScheduleRecurringDay === r.day.value ?
									Object.entries(d.recurringLoad).filter(([key, value]) => value.amount !== "")
										.map(([key, value]) => ({ denominationId: key, amount: value.amount })) : [])
						})
					}
				})

				// }
				this.x = moment(this.model.seasonEnd).format('Y-MM-DD');
				this.expDate = moment(this.model.seasonEnd).format('YYYY-MM-DD');
				this.effDate = moment(this.model.seasonStart).format('YYYY-MM-DD');

				this.Service.create({
					id: this.nextAvailableId,
					name: this.model.name,
					comments: this.model.comments || null,
					active: this.model.status,
					customerId: this.model.customer ? this.model.customer.Value : null,
					// customerContractId: this.model.contract ? this.model.contract.Value : null,
					branchId: this.model.defaultBranch,
					address: this.model._address || null,
					city: this.model._city || null,
					state: this.model._state,
					zip: this.model._zip || null,
					refNumber: this.model.refId ? this.model.refId : null,
					poc: this.model._poc || null,
					phone: this.model.pocPhone || null,
					email: this.model.pocEmail || null,
					balanceType: this.model.balanceType,
					forecastingFlowDirection: this.model.forecastingFlowDirection,
					flowThreshold: this.model.flowThreshold && this.model.balanceType == 'PERCENTAGE' ? this.convertStr(this.model.flowThreshold) / 100 : this.model.flowThreshold,
					routeNotificationDeliveries: this.model.RNdeliveries,
					routeNotificationPickups: this.model.RNpickups,
					routeNotificationNoPickup: this.model.RNnoPickup,
					routeNotificationZeroPickup: this.model.RNzeroPickup,
					defRouteMonId: this.model.Mon.routeId ? this.model.Mon.routeId.Value : null,
					// defRouteMonStop: this.model.Tue.stops,
					defRouteSeqMon: this.model.Mon.options || 1,
					defRouteTueId: this.model.Tue.routeId ? this.model.Tue.routeId.Value : null,
					// defRouteTueStop: this.model.Tue.stops,
					defRouteSeqTue: this.model.Tue.options || 1,
					defRouteWedId: this.model.Wed.routeId ? this.model.Wed.routeId.Value : null,
					// defRouteWedStop: this.model.Wed.stops,
					defRouteSeqWed: this.model.Wed.options || 1,
					defRouteThuId: this.model.Thu.routeId ? this.model.Thu.routeId.Value : null,
					// defRouteThuStop: this.model.Thu.stops,
					defRouteSeqThu: this.model.Thu.options || 1,
					defRouteFriId: this.model.Fri.routeId ? this.model.Fri.routeId.Value : null,
					// defRouteFriStop: this.model.Fri.stops,
					defRouteSeqFri: this.model.Fri.options || 1,
					defRouteSatId: this.model.Sat.routeId ? this.model.Sat.routeId.Value : null,
					// defRouteSatStop: this.model.Sat.stops,
					defRouteSeqSat: this.model.Sat.options || 1,
					defRouteSunId: this.model.Sun.routeId ? this.model.Sun.routeId.Value : null,
					// defRouteSunStop: this.model.Sun.stops,
					defRouteSeqSun: this.model.Sun.options || 1,
					defRouteHolId: this.model.Hol.routeId ? this.model.Hol.routeId.Value : null,
					// defRouteHolStop: this.model.Hol.stops,
					defRouteSeqHol: this.model.Hol.options || 1,
					seasonStart: this.model.seasonStart ? this.effDate : null,
					seasonEnd: this.model.seasonEnd ? this.expDate : null,
					// deliveryBackoutTimes: this.model.deliveryBackoutTimes,
					deliverBagOutPiece: this.model.deliverBagOutPiece,
					individualBagout: this.model.individualBagout,
					centralBank: this.model.centralBank,
					// openTime: this.model.startTime ? moment(this.model.startTime).format('HH:mm:ss') : null,
					// closeTime: this.model.endTime ? moment(this.model.endTime).format('HH:mm:ss') : null,
					deliveryLoc1Id: this.model.deliveryLoc1 || null,
					deliveryLoc2Id: this.model.deliveryLoc2 || null,
					deliveryLocCoinId: this.model.deliveryLocCoin || null,
					deliveryLocCodId: this.model.deliveryLocCod || null,
					locationType: this.model._type,
					keyNum: this.model.keyId || null,
					maxDepositAmount: this.model.maxDepositAmount || null,
					decimalCash: this.model.roundedDeposits,
					codPickup: this.model.codAllow,
					allowMulti: this.model.allowMulti,
					scanLeaveLocation: this.model._leave,
					scanLastTranscation: this.model.lastTransaction,
					verifyToTruck: ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf(this.model._type) > -1 ? this.model.verifyToTruck : false,
					verifyCoinToTruck: ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf(this.model._type) > -1 && this.model.verifyToTruck ? this.model.verifyCoinToTruck : false,
					scanATMCassette: (this.model._type === 'ATM' ? this.model.atmCassette : false),
					maxCassettes: (this.model._type === 'ATM' && this.model.atmCassette) ? parseInt(this.model.maxCassettes, 10) : null,
					packCoinSeparately: !!this.model.packCoinSeparately,
					captureDenomStc: (this.model._type === 'ATM' ? !!this.model.captureDenomStc : false),
					noPrintDelivery: !this.model.TRdeliveries,
					noPrintPickup: !this.model.TRpickups,
					lat: this.model.latitude ? parseFloat(this.model.latitude) : undefined,
					long: this.model.longitude ? parseFloat(this.model.longitude) : undefined,
					deliveryToLocation: this.model.deliveryToLocation || [],
					lockType: this.model.lockType,
					OTCCompanyName: this.model.OTCCompanyName || null,
					stopProcess: this.model.stopProcess || null,
					openTimeSun: this.model.openTimeSun ? moment(this.model.openTimeSun).format('HH:mm:00') : null,
					closeTimeSun: this.model.closeTimeSun ? moment(this.model.closeTimeSun).format('HH:mm:00') : null,
					openTimeMon: this.model.openTimeMon ? moment(this.model.openTimeMon).format('HH:mm:00') : null,
					closeTimeMon: this.model.closeTimeMon ? moment(this.model.closeTimeMon).format('HH:mm:00') : null,
					openTimeTue: this.model.openTimeTue ? moment(this.model.openTimeTue).format('HH:mm:00') : null,
					closeTimeTue: this.model.closeTimeTue ? moment(this.model.closeTimeTue).format('HH:mm:00') : null,
					openTimeWed: this.model.openTimeWed ? moment(this.model.openTimeWed).format('HH:mm:00') : null,
					closeTimeWed: this.model.closeTimeWed ? moment(this.model.closeTimeWed).format('HH:mm:00') : null,
					openTimeThu: this.model.openTimeThu ? moment(this.model.openTimeThu).format('HH:mm:00') : null,
					closeTimeThu: this.model.closeTimeThu ? moment(this.model.closeTimeThu).format('HH:mm:00') : null,
					openTimeFri: this.model.openTimeFri ? moment(this.model.openTimeFri).format('HH:mm:00') : null,
					closeTimeFri: this.model.closeTimeFri ? moment(this.model.closeTimeFri).format('HH:mm:00') : null,
					openTimeSat: this.model.openTimeSat ? moment(this.model.openTimeSat).format('HH:mm:00') : null,
					closeTimeSat: this.model.closeTimeSat ? moment(this.model.closeTimeSat).format('HH:mm:00') : null,
					openTimeHoliday: this.model.openTimeHoliday ? moment(this.model.openTimeHoliday).format('HH:mm:00') : null,
					closeTimeHoliday: this.model.closeTimeHoliday ? moment(this.model.closeTimeHoliday).format('HH:mm:00') : null,
					ATMTransfer: this.model.ATMTransfer,
					OTCGeoFence: this.model.OTCGeoFence,
					closeReq: this.model.closeReq,
					closeEndOfStop: this.model.stopProcess === 'L' && this.model.closeEndOfStop,
					zoneRouting: this.model.zoneRouting,
					stopPriority: ['REGULAR', 'ATM', 'ON_CALL', 'DELIVERY', 'BANK', 'NO_SHIP_NO_GO'].indexOf(this.model._type) > -1 ? this.model.stopPriority : null,
					model: this.model._type === 'ATM' ? this.model.model : null,
					serialNumber: this.model._type === 'ATM' ? this.model.serialNumber : null,
					staticOpenCode: this.model.lockType === 'static' ? this.model.staticOpenCode : null,
					userId: this.model.loggedInUser,
					vaultDate: this.DateUtil.getUTCDate(this.model.setupDetails.currentVaultDate),
					secondaryLock: this.model.secondaryLock,
					secondaryLockId: this.model.secondaryLock ? this.model.secondaryLockId : null,
					secondaryLockType: this.model.secondaryLock ? this.model.secondaryLockType : null,
					secondaryLockOTCCompanyName: this.model.secondaryLock ? this.model.secondaryLockOTCCompanyName : null,
					secondaryLockCloseReq: this.model.secondaryLockType !== 'static' && this.model.secondaryLock ? this.model.secondaryLockCloseReq : false,
					secondaryLockAutoOpen: this.model.secondaryLockType !== 'static' && this.model.secondaryLock ? this.model.secondaryLockAutoOpen : false,
					secondaryLockStaticOpenCode: (this.model.secondaryLock && this.model.secondaryLockType == 'static') ? this.model.secondaryLockStaticOpenCode : null,
					enableOrderProfile: this.model.enableOrderProfile,
					branchFundingSourceId: this.model.enableOrderProfile ? this.model.fundingSourceObj.selectedFundingSource.Value : null,
					branchFundingSourceOrderProfileId: this.model.enableOrderProfile ? this.model.orderProfileObj.selectedOrderProfile.Value : null,
					handleAtmLikeRegular: this.model.handleAtmLikeRegularLocationType.includes(this.model._type) ? this.model.handleAtmLikeRegular : false,
					idBatchImport: this.model.idBatchImport || null,
					idBagoutExport: this.model.idBagoutExport || null,
					idBagoutDepositExport: this.model.idBagoutDepositExport || null,
					idOTCLock: this.model.idOTCLock || null,
					scheduledLocations: this.model.scheduledLocations,
					NFCLock: (this.model.lockType === 'witz' || this.model.lockType === 'TDS') ? this.model.NFCLock : false,
					country: this.model.isNonUSLocation ? this.model.country : 'US',
					NFCScan: this.model.NFCScan,
					NFCTagId: this.model.NFCScan ? this.model.NFCTagId : null,
					distanceFromBranch: this.model.distanceFromBranch,
					travelTimeToBranch: this.model.travelTimeToBranch,
					costCenterId: this.model.costCenter ? this.model.costCenter.Value : null,
					customerCostCenterId: this.model.customerCostCenter ? this.model.customerCostCenter.Value : null,
					accountNumber: this.model.accountNumber ? this.model.accountNumber.trim() : null,
					make: this.parseMakeValues(this.model.make),
					machineOwner: this.model.machineOwner,
					bankSourceId: this.model.bankSourceId ? this.model.bankSourceId.Value : null,
					FLMProvider: this.model.FLMProvider,
					SLMProvider: this.model.SLMProvider,
					bankWeek: this.model.bankWeek,
					optional1: this.model.optional1,
					optional2: this.model.optional2,
					optional3: this.model.optional3,
					frequency: this.model.frequencyOptions,
					dayOfWeek: this.model.dayOfWeekOptions,
					// recurringStops,
					combinedRoutes,
					defRecurringRouteHolId: this.combinedRoutes[7].route ? this.combinedRoutes[7].route.Value : null,
					locationDistanceId: this.model.locationDistanceId ? this.model.locationDistanceId : null,
					contractExpirationDate: this.model.contractExpirationDate ? moment(this.model.contractExpirationDate).format('YYYY-MM-DD') : null,
					// locationDenomination:  this.model.denominationSourceObj.selectedDenomination && this.model._type === 'ATM' ? this.model.denominationSourceObj.selectedDenomination : [],
					locationDenomination: this.model.selectedDenomination,
					liabilityThreshold: this.model.liabilityThreshold ? this.model.liabilityThreshold : null,
					securityThreshold: this.model.securityThreshold ? this.model.securityThreshold : null,
					forecastingStrategy: this.model.forecastingStrategy,
					atmEmptyAtCalculationMethod: this.model.atmEmptyAtCalculationMethod,
					aecPercentChangeValue: this.model.aecPercentChangeValue ? this.convertStr(this.model.aecPercentChangeValue) : 0.5,
					aecPercentChangePeriodA: this.model.aecPercentChangePeriodA ? this.model.aecPercentChangePeriodA : '30D',
					aecPercentChangePeriodB: this.model.aecPercentChangePeriodB ? this.model.aecPercentChangePeriodB : '15D',
					aecWeightedAvgWeightA: this.model.aecWeightedAvgWeightA ? this.model.aecWeightedAvgWeightA : 0.75,
					aecWeightedAvgPeriodA: this.model.aecWeightedAvgPeriodA ? this.model.aecWeightedAvgPeriodA : '30D',
					aecWeightedAvgWeightB: this.model.aecWeightedAvgWeightB ? this.model.aecWeightedAvgWeightB : 0.35,
					aecWeightedAvgPeriodB: this.model.aecWeightedAvgPeriodB ? this.model.aecWeightedAvgPeriodB : '15D',
					aecSinglePeriod: this.model.aecSinglePeriod ? this.model.aecSinglePeriod : '30D',
					addSwapRatio: this.model.addToSwapRatio,
					deliveryCutOff: this.model.deliveryCutOff,
					deliveryCutOffTime: this.model.deliveryCutOff && this.model.deliveryCutOffTime ? moment(this.model.deliveryCutOffTime).format('HH:mm:ss') : null,
					lastRouteStop: this.model._type === 'DELIVERY' ? this.model.lastRouteStop : false,
					targetStopTime: this.model.targetStopTime ? moment(this.model.targetStopTime).format('HH:mm:ss') : null,
					printDeliveryManifest: this.model.printDeliveryManifest,
					podReceipt: this.model.podReceipt,
					locationSlots: this.locationSlots,
					sendManifestOnDelivery: this.model.sendManifestOnDelivery ? this.model.sendManifestOnDelivery : false,
					manifestType: this.model.sendManifestOnDelivery ? this.model.manifestType : null,
					manifestRecipientEmail: this.model.sendManifestOnDelivery ? this.model.manifestRecipientEmail : null,
					zeroAmountPickupRecipientEmail: this.model.sendManifestOnDelivery ? this.model.zeroAmountPickupRecipientEmail : null,
					manifestFileType: this.model.sendManifestOnDelivery ? this.model.manifestFileType : null,
					pickupSLA: this.model.pickupSLA,
					pickupSLATime: this.model.pickupSLA ? this.model.pickupSLATime : null,
					autoRerouteMissed: this.model.autoRerouteMissed,
					packResidual: this.model._type === 'ATM' ? this.model.packResidual : false,
					coinPermitted: this.model._type === 'ATM' ? this.model.coinPermitted : false,
					monthlyCashCountLimit: !!this.model.monthlyCashCountLimit,
					monthlyCashCountLimitAmount: this.model.monthlyCashCountLimitAmount,
					bagoutEnabled: ['BANK', 'DELIVERY'].includes(this.model._type) ? this.model.bagoutEnabled : false,
					bulkTransfer: ['TANKER', 'TRUCK', 'INTERNAL'].includes(this.model._type) ? this.model.bulkTransfer : false,
					isTransferHoldLocation: this.model._type === 'INTERNAL' ? this.model.isTransferHoldLocation : false,
					fallbackFillRate: this.model.fallbackFillRate,
					preventativeMaintenanceId: (['ATM', 'ON_CALL'].includes(this.model._type) && this.model.preventativeMaintenanceId) ? this.model.preventativeMaintenanceId.Value : null,
				})
					.then((data) => {
						this.loading = false
						if (this.success) { // the template is opened in some modal
							this.success(data);
						} else {
							this.askCreate().then((valid) => {
								if (valid) {
									setTimeout(() => {
										this.resetMultiBranchSelection();
										this.previewNextAvailableId();
										this.loadRoutes('', 0);
									}, 500)
								}
							})
						}
					}).
					then(() => {
						this.createLocationBranch();
					})
					.catch((err) => {
						this.loading = false;
						this.previewNextAvailableId();
						if (this.error) { // the template is opened in some modal
							this.error(err);
						}

						if (err && err.data && err.data.errors) {
							err.data.errors.map((e) => {
								if (e && e.path == "LOCATION.refNumber") {
									this.errorMessage = this.$translate.instant('location.refNumberUnique');
									this.Modal.errorModal(this.errorMessage);
								}
								else if (e && e.path == 'LOCATION.NFCTagId') {
									this.errorMessage = this.$translate.instant('common.unique_nfc_tag_id');
									this.Modal.errorModal(this.errorMessage);
								}
								else {
									this.errorMessage = (e.value === "1009") ? this.$translate.instant(`common.error_${(e.path).toLowerCase()}_key`) : e.message + '<br/>';
									this.Modal.errorModal(this.errorMessage);
								}
							})
						}
						else if (err && err.data && err.data.message) {
							this.Modal.errorModal(err.data.message);
						}
					})
			})
	}

	autoDetect() {
		if (!this.render) return;

		let address = '';

		if (this.model._address) address += this.model._address + ", ";
		if (this.model._city) address += this.model._city + ", ";
		if (this.model._state) address += this.model._state + ", ";
		if (this.model._zip) address += this.model._zip;

		this.model.updatingDrivingDistance = true;

		if (['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'ON_CALL', 'DELIVERY'].indexOf(this.model._type) > -1
			&& this.maintainDriveDistance && this.model.status) {

			return this.Service.getLocationDrivingDistance(address, this.formatAddress(this.model.setupDetails))
				.then((data) => {
					if (data.status) {
						if (_.isEmpty(data.results)) {
							return Promise.reject('location.invalidAddress');
						}
						else if (data.results.status === 'NOT_FOUND') {
							return Promise.reject('location.not_found');
						}
						else if (data.results.status === 'ZERO_RESULTS') {
							return Promise.reject('location.zero_results');
						} else {
							this.model.distanceFromBranch = data.results.distance.text;
							this.model.travelTimeToBranch = data.results.duration.text;
							this.model.locationDistance = data.results.locationDistance ? data.results.locationDistance.label : '';
							this.model.locationDistanceId = data.results.locationDistance ? data.results.locationDistance.id : '';
							return this.locationGeoCodes(address);
						}
					}
					else return Promise.reject(data.errorMessage);
				})
				.catch((err) => {
					this.Modal.errorModal(err);
					return Promise.reject();
				})
				.finally(() => {
					this.model.updatingDrivingDistance = false;
				})
		}
		else {
			this.model.updatingDrivingDistance = false;
			return this.locationGeoCodes(address)
		}
	}

	locationGeoCodes(address) {
		const defer = this.$q.defer();

		if (address == '') {
			this.loading = false;
			return defer.resolve();
		}
		const geocoder = new google.maps.Geocoder();
		const results = geocoder.geocode({ 'address': address });
		if (!results || results.length == 0) return defer.resolve();

		geocoder.geocode({ 'address': address }, (results, status) => {
			if (status === 'OK') {
				let latitude = results[0].geometry.location.lat();
				let longitude = results[0].geometry.location.lng();
				this.setMarkerPosition(latitude, longitude);
				this.$scope.$apply();
				return defer.resolve();
			}
			else if (status === 'NOT_FOUND') {
				this.loading = false;
				this.Modal.errorModal('location.not_found');
				return defer.reject();
			}
			else if (status === 'ZERO_RESULTS') {
				this.loading = false;
				if (this.maintainDriveDistance) this.Modal.errorModal('location.zero_results');
				else if (!this.maintainDriveDistance) this.Modal.errorModal('location.invalidAddress');
				return defer.reject();
			}
			else {
				this.Modal.errorModal('location.invalidAddress');
				this.loading = false;
				return defer.reject();
			}
		})
		return defer.promise;
	}


	getAddressFromLatLng(lat, lng) {
		const defer = this.$q.defer();

		if (!lat || !lng) {
			this.loading = false;
			return defer.resolve();
		}

		const geocoder = new google.maps.Geocoder();
		const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

		geocoder.geocode({ location: latlng }, (results, status) => {
			if (status === 'OK' && results && results.length > 0) {
				const result = results[0];
				const addressComponents = result.address_components;

				let locationData = {
					address: '',
					city: '',
					country: '',
					state: '',
					zip: ''
				};

				for (const component of addressComponents) {
					const types = component.types;
					let locAddress = null;
					if (types.length === 0) locAddress = component.long_name;
					else if (types.includes('street_number')) locAddress = component.short_name;
					else if (types.includes('route')) locAddress = component.long_name;

					if (locAddress) {
						locationData.address = [locationData.address, locAddress].filter(Boolean).join(' ');
					}
					if (types.includes('locality')) {
						locationData.city = component.long_name;
					}
					if (types.includes('country')) {
						locationData.country = component.long_name;
					}
					if (types.includes('administrative_area_level_1')) {
						locationData.state = component.long_name;
					}
					if (types.includes('postal_code')) {
						locationData.zip = component.long_name;
					}
				}
				this.model._address = locationData.address;
				this.model._city = locationData.city;
				this.model.country = locationData.country;
				this.model._zip = locationData.zip;
				if (this.model.isNonUSLocation) {
					this.model._state = locationData.state;
				} else {
					const matchedState = this.states.find(
						state => state.label.toLowerCase() === locationData.state.toLowerCase()
					);
					this.model._state = matchedState ? matchedState.value : '';
				}

				this.loading = false;
				this.$scope.$apply();

				return defer.resolve(locationData);
			}
			else if (status === 'ZERO_RESULTS' || status === 'NOT_FOUND') {
				this.loading = false;
				this.Modal.errorModal('location.not_found');
				return defer.reject('No results found');
			}
			else {
				this.loading = false;
				this.Modal.errorModal('location.invalidAddress');
				return defer.reject('Geocoder failed: ' + status);
			}
		});

		return defer.promise;
	}

	setMarkerPosition(lat, lng) {
		let self = this;
		if (!lat && !lng) {
			var lat = document.getElementById("lat").value;
			var lng = document.getElementById("lng").value;
		}
		else {
			if (lat && lng) {
				this.getAddressFromLatLng(lat, lng)
			}
			document.getElementById("lat").value = lat;
			document.getElementById("lng").value = lng;
			self.model.latitude = document.getElementById("lat").value
			self.model.longitude = document.getElementById("lng").value;
		}

		var oldMarker;

		var latlng = new google.maps.LatLng(lat, lng);

		var options = { zoom: 16, center: latlng, mapTypeId: google.maps.MapTypeId.ROADMAP }

		var map = new google.maps.Map(document.getElementById("map"), options);

		oldMarker = new google.maps.Marker({ position: latlng, map: map, draggable: true });

		google.maps.event.addListener(oldMarker, "dragend", (event) => {
			var dragLat = event.latLng.lat();
			var dragLng = event.latLng.lng();
			if (dragLat && dragLng) {
				this.getAddressFromLatLng(dragLat, dragLng)
			}
			document.getElementById("lat").value = dragLat;
			document.getElementById("lng").value = dragLng;
			self.model.latitude = dragLat;
			self.model.longitude = dragLng;
			self.$scope.$apply();
		});

		google.maps.event.addListener(map, "click", (event) => {
			// get lat/long of click
			var clickLat = event.latLng.lat();
			var clickLong = event.latLng.lng();

			if (clickLat && clickLong) {
				this.getAddressFromLatLng(clickLat, clickLong)
			}

			// show in input box
			document.getElementById("lat").value = clickLat;
			document.getElementById("lng").value = clickLong;

			self.model.latitude = clickLat;
			self.model.longitude = clickLong;

			var marker = new google.maps.Marker({ position: new google.maps.LatLng(clickLat, clickLong), map: map, draggable: true });

			if (oldMarker != undefined) { oldMarker.setMap(null); }
			oldMarker = marker;

			google.maps.event.addListener(marker, "dragend", (event) => {
				var dragLat = event.latLng.lat();
				var dragLng = event.latLng.lng();
				if (dragLat && dragLng) {
					this.getAddressFromLatLng(dragLat, dragLng)
				}
				document.getElementById("lat").value = dragLat;
				document.getElementById("lng").value = dragLng;
				self.model.latitude = dragLat;
				self.model.longitude = dragLng;
				self.$scope.$apply();
			});
		});

		if (this.maintainDriveDistance) {
			this.marker = new google.maps.Marker({
				position: new google.maps.LatLng(this.model.setupDetails.gpsLat, this.model.setupDetails.gpsLong),
				map: map,
				label: {
					text: 'B',
					color: 'white',
					fontWeight: 'bold',
				}
			});

			const branchInfoPopup = new google.maps.InfoWindow({
				content: `
				<h6>Branch Address</h6>
				<p>${this.model.setupDetails.address}, ${this.model.setupDetails.city}, 
				   ${this.model.setupDetails.state}, ${this.model.setupDetails.zip}</p>
			`
			});

			this.marker.addListener('click', () => {
				branchInfoPopup.open({
					anchor: this.marker,
					map
				});
			});
		}
	}

	branchLocation() {
		const branchLocation = this.model.setupDetails,
			mapElement = document.getElementById('map'),
			locationLatitude = document.getElementById("lat").value,
			locationLongitude = document.getElementById("lng").value;

		var map = new google.maps.Map(mapElement, {
			zoom: 16,
			center: new google.maps.LatLng(locationLatitude, locationLongitude),
			mapTypeId: google.maps.MapTypeId.ROADMAP
		});

		const branchInfoPopup = new google.maps.InfoWindow({
			content: `
				<h6>Branch Address</h6>
				<p>${this.model.setupDetails.address}, ${this.model.setupDetails.city}, 
				   ${this.model.setupDetails.state}, ${this.model.setupDetails.zip}</p>
			`
		});

		new google.maps.Marker({
			position: new google.maps.LatLng(locationLatitude, locationLongitude),
			map,
		});

		this.marker = new google.maps.Marker({
			position: new google.maps.LatLng(branchLocation.gpsLat, branchLocation.gpsLong),
			map,
			label: {
				text: 'B',
				color: 'white',
				fontWeight: 'bold'
			}
		});

		this.marker.addListener('click', () => {
			branchInfoPopup.open({
				anchor: this.marker,
				map
			});
		});
	}


	loadConfigs() {
		this.Configs.getConfigs()
			.then((data) => {
				this.googleMapConfig = data.googleMap;
				this.maintainDriveDistance = data.maintainDriveDistance;
				this.apiKey = '//maps.google.com/maps/api/js?key=' + this.googleMapConfig.key + '&libraries=places'
				setTimeout(() => {
					this.render = true;
				}, 100)
				setTimeout(() => {
					this.render = true;
					if (this.maintainDriveDistance) this.branchLocation();
				}, 1000)
				return data
			})
			.then((data) => {
				this.companyMapping(data.otcCompanyList);
			})
			.catch((err) => {
				console.log(err)
			});
	}

	sameOperationTime() {
		this.contractDays = [];
		this.operationDays.forEach((data) => {
			this.contractDays[data.value] = true;
		})

		if (this.model.isSameOperationTime) {
			for (let day in this.contractDays) {
				if (this.contractDays[day]) {
					this.model[this.openTime + day] = ''
					this.model[this.closeTime + day] = ''
				}
			}
		}
	}

	updateTime(selectedDay) {
		if (this.model.isSameOperationTime) {
			if (this.contractDays[selectedDay]) {
				for (let day in this.contractDays) {
					if (this.contractDays[day]) {
						this.model[this.openTime + day] = this.model[this.openTime + selectedDay]
						this.model[this.closeTime + day] = this.model[this.closeTime + selectedDay]
					}
				}
			}
		}
	}

	companyMapping(data) {
		this.OTCCompanyNameList = this.CommonLayoutService.OTCCompanyMapping(data);
	}

	getSetupDetails() {
		if (!this.model.defaultBranch) {
			return this.model.setupDetails = "";
		}
		this.SetupService.get(this.model.defaultBranch)
			.then((data) => {
				this.model.setupDetails = data;
			})
			.catch((err) => {
				console.log(err);
			})
	}

	autoDetectGeoCoordinates() {
		this.isAutoDetectOnFormSubmit = false;
		this.autoDetect();
	}

	showPassword(stat, type) {
		this.passWdIcon[stat][type] = !this.passWdIcon[stat][type];
	}

	resetOTCCompany() {
		if (this.model.lockType === 'static') this.model.OTCCompanyName = null;
		if (this.model.secondaryLockType === 'static') this.model.secondaryLockOTCCompanyName = null;
	}

	fundingSourceSearchObj(searchKey) {
		searchKey = searchKey || '';
		const selectedBranch = Array.isArray(this.model.branch) ? this.model.branch.map((branch) => branch.branchId) : this.model.currentBranch.split();

		const obj = {
			queryJSON: {
				rules: [
					{
						field: "branchId",
						condition: "=",
						data: this.model.defaultBranch ? this.model.defaultBranch : selectedBranch
					},
					{
						group: {
							rules: [
								{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "sourceName",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					}
				],
				operator: "AND"
			}
		}
		return obj.queryJSON.rules.length ? obj : null;
	}

	getAllFundingSource(searchKey, offset) {
		this.model.fundingSourceObj.loading = true;
		const searchObj = this.fundingSourceSearchObj(searchKey);

		this.BranchFundingSourceService.all(searchObj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.model.fundingSourceObj.totalRecords = data.total;
					this.model.fundingSourceObj.results = this.fundingSourceDataMap(data.results);
				}
				else {
					const fundingSource = this.fundingSourceDataMap(data.results);
					this.model.fundingSourceObj.results = (this.model.fundingSourceObj.results || []).concat(fundingSource);
				}
			})
			.catch((err) => {
				this.Modal.errorModal(err.data.message);
			})
			.finally(() => {
				this.model.fundingSourceObj.loading = false;
			})
	}

	fundingSourceDataMap(list) {
		return list.map((bfs) => {
			return {
				Key: bfs.id + ' | ' + bfs.sourceName,
				Value: bfs.id,
				Obj: bfs
			}
		})
	}

	orderProfileSearchObj(searchKey) {
		if (!this.model.fundingSourceObj.selectedFundingSource) return;
		searchKey = searchKey || '';
		const obj = {
			queryJSON: {
				rules: [
					{
						field: "branchFundingSourceId",
						condition: "=",
						data: this.model.fundingSourceObj.selectedFundingSource.Value
					},
					{
						group: {
							rules: [
								{
									field: "name",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "loadInterval",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					}
				],
				operator: "AND"
			}
		}
		return obj.queryJSON.rules.length ? obj : null;
	}

	getOrderProfile(searchKey, offset) {
		this.model.orderProfileObj.loading = true;
		const searchObj = this.orderProfileSearchObj(searchKey);

		this.BranchFundingSourceOrderProfileService.all(searchObj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.model.orderProfileObj.totalRecords = data.total;
					this.model.orderProfileObj.results = this.orderProfileDataMap(data.results);
				}
				else {
					const fundingSource = this.orderProfileDataMap(data.results);
					this.model.orderProfileObj.results = (this.model.orderProfileObj.results || []).concat(fundingSource);
				}
			})
			.catch((err) => {
				this.Modal.errorModal(err.data.message);
			})
			.finally(() => {
				this.model.orderProfileObj.loading = false;
			})
	}

	orderProfileDataMap(list) {
		return list.map((op) => {
			return {
				Key: op.name + ' | ' + op.loadInterval,
				Value: op.id
			}
		})
	}

	resetDataOnBranchChange() {
		if (this.model.enableOrderProfile) {
			this.model.fundingSourceObj.selectedFundingSource = null;
			this.model.orderProfileObj.selectedOrderProfile = null;
		}
		this.model.bankSourceId = null;
	}

	createLocationScheduled() {
		if (this.model.scheduledLocations.length <= 0) this.routeList('', 0);

		this.minVaultDate = {
			minDate: this.model.setupDetails.currentVaultDate
		}
		this.model.scheduledLocations.push({
			vaultDate: null,
			routeId: null,
			sequence: 99,
			status: 'Create',
			scheduleLocationId: null
		})
	}

	routeList(searchKey, offset) {
		searchKey = searchKey || '';

		const selectedBranch = this.model.branch.map((branch) => branch.branchId)
		const searchObj = {
			queryJSON: {
				rules: [{
					field: 'branchId',
					condition: 'IN',
					data: selectedBranch
				},
				{
					field: 'holdRoute',
					condition: '=',
					data: false
				},
				{
					field: 'active',
					condition: '=',
					data: true
				},
				{
					group: {
						rules: [{
							field: 'id',
							condition: 'like',
							data: '%' + searchKey + '%'
						},
						{
							field: 'name',
							condition: 'like',
							data: '%' + searchKey + '%'
						}
						],
						operator: 'OR'
					}
				}
				],
				operator: 'AND'
			}
		}

		this.model.routeListObj.loading = true;
		return this.RouteService.all(searchObj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.model.routeListObj.totalRecords = data.total;
					this.model.routeListObj.results = this.mapData(data.results);
				} else {
					const routes = this.mapData(data.results);
					this.model.routeListObj.results = this.model.routeListObj.results.concat(routes);
				}
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					Modal.errorModal(err.data.message);
				}
			})
			.finally(() => {
				this.model.routeListObj.loading = false;
			})
	}

	mapData(routes) {
		return routes.map((route) => {
			return {
				Key: route.name,
				Value: route.id
			}
		});
	}

	deleteScheduledLocation(index) {
		this.model.scheduledLocations.splice(index, 1);
		this.validateScheduledLocation();
	}

	validateScheduledLocation() {
		this.model.scheduledLocations = _.map(this.model.scheduledLocations, (obj, index) => {
			obj.isDuplicate = false;
			let match = _.find(this.model.scheduledLocations, (compairObject, compairObjIndex) => {
				if (index > compairObjIndex) return new Date(compairObject.vaultDate).getDate() == new Date(obj.vaultDate).getDate();
			});
			if (match) {
				obj.isDuplicate = true;
				return obj;
			} else {
				return obj;
			}
		});
		let isValid = this.model.scheduledLocations.map((obj) => {
			if (obj.isDuplicate) return true;
		})
		this.isValid = isValid.indexOf(true) >= 0 ? false : true;
	}

	resetText() {
		this.model._state = null;
		this.model.country = null;
	}

	parseMakeValues(makeValue) {
		if (Array.isArray(makeValue)) {
			return makeValue
				.map((item) => {
					if (!item) return null;
					if (typeof item === 'string') {
						const vendorName = item.trim();
						return vendorName ? { atmMakeId: null, vendorName } : null;
					}
					const vendorName = (item.vendorName || item.Value || item.value || item.Key || item.label || '').trim();
					const atmMakeId = item.atmMakeId || item.id || (item.atmMake && item.atmMake.id) || null;
					return vendorName ? { atmMakeId, vendorName } : null;
				})
				.filter(Boolean);
		}

		if (!makeValue) return [];

		return String(makeValue)
			.split(',')
			.map((item) => item.trim())
			.filter(Boolean)
			.map((vendorName) => ({ atmMakeId: null, vendorName }));
	}

	serializeMakeValues(makeValue) {
		const values = this.parseMakeValues(makeValue);
		return values.length ? values.map((item) => item.vendorName).join(', ') : null;
	}

	buildAtmMakeOptions(results, selectedMakes) {
		const selectedValues = this.parseMakeValues(selectedMakes);
		const selectedById = selectedValues.map((item) => item.atmMakeId).filter(Boolean);
		const selectedByName = selectedValues.map((item) => item.vendorName).filter(Boolean);
		const options = (results || [])
			.filter((item) => item.active)
			.map((item) => ({
				Key: item.vendorName,
				Value: item.vendorName,
				id: item.id,
				atmMakeId: item.id,
				vendorName: item.vendorName,
				ticked: selectedById.includes(item.id) || selectedByName.includes(item.vendorName)
			}));

		selectedValues.forEach((selectedItem) => {
			if (options.findIndex((item) => item.atmMakeId === selectedItem.atmMakeId || item.Value === selectedItem.vendorName) === -1) {
				options.push({
					Key: selectedItem.vendorName,
					Value: selectedItem.vendorName,
					id: selectedItem.atmMakeId || selectedItem.vendorName,
					atmMakeId: selectedItem.atmMakeId,
					vendorName: selectedItem.vendorName,
					ticked: true
				});
			}
		});

		return options;
	}

	loadAtmMakes(selectedMakes = this.model.make) {
		return this.AtmMakesService.all('', 0, 1000, true)
			.then(({ results }) => {
				this.atmMakesList = this.buildAtmMakeOptions(results, selectedMakes);
				this.model.make = this.parseMakeValues(selectedMakes);
			})
			.catch((err) => {
				console.log(err);
				this.atmMakesList = [];
				this.model.make = [];
			});
	}

	formatAddress(data) {
		let locationAddress = '';
		if (data.address) locationAddress = locationAddress.concat(data.address, ', ');
		if (data.city) locationAddress = locationAddress.concat(data.city, ', ');
		if (data.state) locationAddress = locationAddress.concat(data.state, ', ');
		if (data.zip) locationAddress = locationAddress.concat(data.zip);
		return locationAddress;
	}

	filterStopProcess() {
		if (this.model.stopProcess !== 'L') this.model.closeEndOfStop = false;
		if (!this.model._type) return;

		const typeMap = {
			ATM: ['L', 'A'],
			ON_CALL: ['D', 'B'],
			REGULAR: ['D'],
			NO_SHIP_NO_GO: ['D'],
			BANK: ['D'],
			DELIVERY: ['D'],
			INTERNAL: ['D']
		};

		const allowed = typeMap[this.model._type];
		const list = this.CommonLayoutService.stopProcessList();
		this.stopProcessList = allowed ? list.filter(({ value }) => allowed.includes(value)) : list;
		if (allowed && !allowed.includes(this.model.stopProcess)) {
			this.model.stopProcess = null;
		}
	}

	createLocationRecurring() {
		if (this.model.recurringStops.length <= 0) this.routeList('', 0);

		this.model.recurringStops.push({
			description: null,
			route: null,
			sequence: 99,
			status: 'Create',
			anchorDate: null,
			effectiveTillDate: null,
			interval: null,
			frequency: 99,
			minEndDate: {}
		});
	}

	deleteRecurringLocation(index) {
		this.model.recurringStops.splice(index, 1);
		this.validateRecurringLocation();
	}

	validateRecurringLocation() {
		this.model.recurringStops = _.map(this.model.recurringStops, (obj, index) => {
			obj.isDuplicate = false;
			let match = _.find(this.model.recurringStops, (compairObject, compairObjIndex) => {
				if (index > compairObjIndex) {
					return new Date(compairObject.anchorDate).getDate() == new Date(obj.anchorDate).getDate() &&
						(compairObject.route && obj.route ? compairObject.route.Value == obj.route.Value : true) && compairObject.interval == obj.interval
				}
			});
			if (match) {
				obj.isDuplicate = true;
				return obj;
			} else {
				return obj;
			}
		});
		let isValid = this.model.recurringStops.map((obj) => {
			if (obj.isDuplicate) return true;
		})
		this.isValidRecurringStops = isValid.indexOf(true) >= 0 ? false : true;
	}

	validateReccuringEndDate(obj) {
		obj.minEndDate = {
			minDate: moment(obj.anchorDate)
		}
		if (obj.effectiveTillDate && obj.anchorDate > obj.effectiveTillDate) {
			obj.effectiveTillDate = moment(obj.anchorDate)
		}
	}

	disableDays(currentDate, mode, enableDay) {
		if (enableDay.value === "Hol") return false;
		return mode === 'day' && (currentDate.getDay() !== this.dayMap[enableDay.value]);
	};

	recheckMonthlyOccurences(anchorDate, day, index) {
		if (!anchorDate) return;
		const selectedDate = new Date(anchorDate);
		const month = selectedDate.getMonth() + 1;
		const year = selectedDate.getFullYear();
		let occurrences = this.countOccurrencesInMonth(year, month, this.dayMap[day.value]);

		switch (occurrences) {
			case 2:
				this.combinedRoutes[index].combinedRouteIntervals = [...this.combinedRouteIntervals].slice(0, -3);
				break;
			case 3:
				this.combinedRoutes[index].combinedRouteIntervals = [...this.combinedRouteIntervals].slice(0, -2);
				break;
			case 4:
				this.combinedRoutes[index].combinedRouteIntervals = [...this.combinedRouteIntervals].slice(0, -1);
				break;
			default:
				this.combinedRoutes[index].combinedRouteIntervals = [...this.combinedRouteIntervals];
				break;
		}
		if (this.combinedRoutes[index].interval && this.combinedRoutes[index].interval.interval === "MONTHOC" && this.combinedRoutes[index].interval.frequency > occurrences) {
			this.combinedRoutes[index].interval = null;
		}
	}

	countOccurrencesInMonth(year, month, targetDay) {
		let count = 0;
		const startDate = new Date(year, month - 1, 1);
		const endDate = new Date(year, month, 0);

		for (let currentDate = startDate; currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
			if (currentDate.getDay() === targetDay) {
				count++;
			}
		}

		return count;
	}

	resetCombinedRoutes() {
		this.createCombinedRoutes();
	}

	denominationsSearchObj(searchKey) {
		searchKey = searchKey || '';

		const obj = {
			queryJSON: {
				rules: [
					{
						group: {
							rules: [
								{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "name",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					},
					{
						field: "coinFlag",
						condition: "=",
						data: 0
					}
				],
				operator: "AND"
			}
		};
		return obj.queryJSON.rules.length ? obj : null;
	}

	getAllDenominations(searchKey, offset) {
		if (!this.model.bankSourceId) return;

		this.model.denominationSourceObj.loading = true;
		// const searchObj = this.denominationsSearchObj(searchKey);

		return this.OrderViewService.getFundingSourceDenominationUnpack(this.model.bankSourceId.Value)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.model.denominationSourceObj.totalRecords = data.results.length;
					this.model.denominationSourceObj.results = this.denominationsDataMap(data.results);
				}
				else {
					const denominations = this.denominationsDataMap(data.results);
					this.model.denominationSourceObj.results = this.model.denominations.concat(denominations);
				}
				this.getFilteredDenominations();
			})
			.catch((err) => {
				this.Modal.errorModal(err.data.message);
			})
			.finally(() => {
				this.model.denominationSourceObj.loading = false;
			})
	}

	getAllLocationSlotDenominations(searchKey, offset) {
		return this.DenominationService.all(searchKey, offset, 1000)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.model.locationSlotDenominations.totalRecords = data.results.length;
					this.model.locationSlotDenominations.results = this.denominationsDataMap(data.results);
				}
				else {
					const denominations = this.denominationsDataMap(data.results);
					this.model.locationSlotDenominations.results = this.model.locationSlotDenominations.concat(denominations);
				}
			})
			.catch((err) => {
				this.Modal.errorModal(err.data.message);
				this.model.locationSlotDenominations.results = [];
			})
	}

	getFilteredDenominations() {
		this.model.selectedDenomination = [];
		this.locationRecurringLoad = [];
		this.filteredDenominations = {
			results: [],
			totalRecords: 0,
		};

		if (this.model._type === 'ATM') {
			this.filteredDenominations.results = this.model.denominationSourceObj.results.filter(denom => {
				if (!denom.coinFlag) {
					return true;
				}
				if (denom.coinFlag && this.model.coinPermitted && denom.multiDenomPackable &&
					denom.coinPackaging && ['INDIVIDUAL', 'ROLLED'].includes(denom.coinPackaging)) {
					return true;
				}
				return false;
			});
			this.filteredDenominations.totalRecords = this.filteredDenominations.results.length;
		}
		else {
			this.filteredDenominations.results = this.model.denominationSourceObj.results;
			this.filteredDenominations.totalRecords = this.filteredDenominations.results.length;
		}
	};

	denominationsDataMap(list) {
		return list.map((denom) => {
			return {
				id: denom.id,
				Key: denom.id + ' | ' + denom.name,
				Value: denom.id,
				strapCount: denom.strapCount,
				faceValue: denom.faceValue,
				coinFlag: denom.coinFlag,
				shiptypeId: denom.shiptypeId,
				multiDenomPackable: denom.multiDenomPackable,
				coinPackaging: denom.coinPackaging
			}
		})
	}

	createLocationRecurringLoad() {
		if (['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO'].indexOf(this.model._type) === -1) {
			this.locationRecurringLoad = [];
			return;
		}

		setTimeout(() => {
			this.days.forEach(day => {
				this.locationRecurringLoad.push({
					day: day,
					denominations: this.model.selectedDenomination,
					recurringLoad: {}
				})
			});

			const uniqueDayMap = new Map();

			for (let i = 0; i < this.locationRecurringLoad.length; i++) {
				const item = this.locationRecurringLoad[i];
				const dayValue = item.day.value;

				if (!uniqueDayMap.has(dayValue)) {
					uniqueDayMap.set(dayValue, { ...item, denominations: [...item.denominations] });
				} else {
					const existingItem = uniqueDayMap.get(dayValue);
					const existingDenominationIds = new Set(existingItem.denominations.map(denom => denom.id));
					const uniqueDenominations = item.denominations.filter(denom => !existingDenominationIds.has(denom.id));
					existingItem.denominations.push(...uniqueDenominations);

					if (Object.keys(existingItem.recurringLoad).length === 0 && Object.keys(item.recurringLoad).length > 0) {
						existingItem.recurringLoad = item.recurringLoad;
					}
				}
			}

			this.locationRecurringLoad = Array.from(uniqueDayMap.values());

			this.locationRecurringLoad.forEach(item => {
				// Filter out denominations
				item.denominations = item.denominations.filter((denom) => { denom && denom.denom ? denom.denom.Value : null });
				const newDenomination = this.model.selectedDenomination.filter(denom => denom.isNew && denom.denom); //add new denomination
				if (newDenomination.length > 0) item.denominations.push(...newDenomination);

				const validDenominationIds = new Set(item.denominations.map(denom => denom.denom ? denom.denom.Value : null));
				Object.keys(item.recurringLoad).forEach(key => { if (!validDenominationIds.has(key)) delete item.recurringLoad[key] });
			});

			this.validateRouteAssignment();
			this.$scope.$apply();
		}, 100);
	}

	checkDenomKeyExists() {
		let isValid = this.model.selectedDenomination.map(d => {
			return !d.denom || 'isEmpty'
		}).indexOf('isEmpty') !== -1
		return isValid;
	}

	checkForStrapCount() {
		for (let i = 0; i < this.locationRecurringLoad.length; ++i) {
			for (let j = 0; j < this.locationRecurringLoad[i].denominations.length; ++j) {
				const denomination = this.locationRecurringLoad[i].denominations[j];
				const recurringLoad = this.locationRecurringLoad[i]['recurringLoad'];
				if (denomination.denom && denomination.denom.strapCount && recurringLoad && recurringLoad[denomination.denom.Value] && !denomination.denom.coinFlag) {
					const loadAmount = recurringLoad[denomination.denom.Value].amount;
					const faceValue = denomination.denom.faceValue;

					if (loadAmount !== undefined && loadAmount !== null && loadAmount !== '' &&
						(loadAmount / faceValue) % denomination.denom.strapCount !== 0) {
						recurringLoad[denomination.denom.id].isValid = false;
					} else {
						recurringLoad[denomination.denom.id].isValid = true;
					}
				}
				else if (recurringLoad && recurringLoad[denomination.denom.Value] && denomination.denom.coinFlag) {
					recurringLoad[denomination.denom.id].isValid = true;
				}
			}
		}
		this.isValidRecurringLoad = this.checkRecurringLoadValidity(this.locationRecurringLoad);
	}

	checkForMaxLoadFaceValueDivisibility() {
		this.isValidMaxLoad = true;
		if (!this.model.selectedDenomination || !this.model.selectedDenomination.length) {
			return true;
		}

		function isValidAmount(amount, faceValue) {
			if (!isFinite(amount) || !isFinite(faceValue) || faceValue <= 0 || amount <= 0) {
				return false;
			}
			const quotient = amount / faceValue;
			const epsilon = 1e-9;
			return Math.abs(quotient - Math.round(quotient)) < epsilon;
		}

		this.model.selectedDenomination.forEach((denomObj) => {
			denomObj.isMaxLoadValid = true;

			const denom = denomObj.denom;
			const faceValueRaw = denom && denom.faceValue;
			const maxLoadRaw = denomObj.maxLoad;

			// Don't block until user selects denomination and enters maxLoad
			if (!denom || faceValueRaw === undefined || faceValueRaw === null || maxLoadRaw === undefined || maxLoadRaw === null || maxLoadRaw === '') {
				return;
			}

			const faceValue = Number(String(faceValueRaw).replace(/,/g, ''));
			const maxLoad = Number(String(maxLoadRaw).replace(/,/g, ''));

			if (!isFinite(faceValue) || faceValue === 0 || !isFinite(maxLoad)) {
				denomObj.isMaxLoadValid = false;
				return;
			}

			denomObj.isMaxLoadValid = isValidAmount(maxLoad, faceValue);
		});

		this.isValidMaxLoad = this.model.selectedDenomination.every((denomObj) => {
			if (!denomObj.denom) return true;
			return denomObj.isMaxLoadValid !== false;
		});

		return this.isValidMaxLoad;
	}

	isValidTargetStopTime() {
		if (!this.model.targetStopTime) return true;
		return this.model.targetStopTime.getHours() > 0 || this.model.targetStopTime.getMinutes() > 0;
	}

	validateRouteAssignment() {
		this.totalRouteAssignment = 0;

		const routeMap = new Map();
		this.combinedRoutes.forEach((route) => {
			if (route.route && route.sequence && route.anchorDate && route.interval) {
				routeMap.set(route.day.value, route);
			}
		});

		this.locationRecurringLoad.forEach((location) => {
			const route = routeMap.get(location.day.value);

			if (route) {
				this.totalRouteAssignment++;
				location.locationScheduleRecurringDay = route.day.value;
				location.hasLocationScheduleRecurring = true;
			} else {
				location.hasLocationScheduleRecurring = false;
				location.recurringLoad = {};
			}
		});
	}

	checkRecurringLoadValidity(data) {
		let isValidFlag = true;
		for (let item of data) {
			if (item.recurringLoad) {
				for (let key in item.recurringLoad) {
					const isValid = item.recurringLoad[key].isValid;
					if (!isValid) return false;
					if (isValid) isValidFlag = true;
				}
			}
		}
		return isValidFlag;
	}

	convertStr(str) {
		if (!str) return;
		return Number(str.replace('%', ''));
	}

	ngPercentage() {
		if (this.model.aecPercentChangeValue && !String(this.model.aecPercentChangeValue).endsWith('%')) {
			return this.model.aecPercentChangeValue = this.model.aecPercentChangeValue + '%';
		}
	}

	removePercentageSign() {
		if (this.model.aecPercentChangeValue && String(this.model.aecPercentChangeValue).endsWith('%')) {
			return this.model.aecPercentChangeValue = String(this.model.aecPercentChangeValue).replace('%', '');
		}
	}

	createLocationDenomination() {
		// if(this.model.selectedDenomination.length <= 0) this.getAllDenominations('', 0);
		// this.model.selectedDenomination.push({
		// 	denom: null,
		// 	maxLoad: this.model._type === 'ATM' ? null : 0,
		// 	minResidualThreshold: this.model._type === 'ATM' ? null : 0,
		// 	maxResidualThreshold: this.model._type === 'ATM' ? null : 0,
		// 	minResidualThresholdPercentage: this.model._type === 'ATM' ? null : '0%',
		// 	maxResidualThresholdPercentage: this.model._type === 'ATM' ? null : '0%',
		// 	status: 'Create',
		// 	isNew: true,
		// 	disableFields: this.model._type === 'ATM' ? false : true
		// });
		this.model.selectedDenomination.push({
			denom: null,
			maxLoad:null,
			minResidualThreshold:null,
			maxResidualThreshold:null,
			minResidualThresholdPercentage:null,
			maxResidualThresholdPercentage:null,
			status: 'Create',
			isNew: true,
			disableFields: false
		});
	}

	deleteDenominationSelected(index) {
		this.model.selectedDenomination.splice(index, 1);
		this.validateDenominationSelected();
		this.createLocationRecurringLoad();
	}

	createLocationSlots() {
		if (!this.model.locationSlotDenominations.results) {
			this.model.locationSlotDenominations.results = [];
		}
		const mxdDenominations = this.model.locationSlotDenominations.results.filter(d => d.shiptypeId === 'MXD');
		this.locationSlots.push({
			denominationId: mxdDenominations[0] || null,
			slotTrackingId: '',
		});
		this.validateLocationSlotsDuplicate();
	}

	deleteLocationSlotsSelected(index) {
		this.locationSlots.splice(index, 1);
		this.validateLocationSlotsDuplicate();
	}

	validateDenominationSelected() {
		this.model.selectedDenomination = _.map(this.model.selectedDenomination, (mainObj, mainIndex) => {
			// if (mainObj.denom && (mainObj.denom.coinFlag || this.model._type !== 'ATM')) {
			// 	mainObj.maxLoad = 0;
			// 	mainObj.minResidualThreshold = 0;
			// 	mainObj.maxResidualThreshold = 0;
			// 	mainObj.disableFields = true;
			// }
			// else {
			// 	mainObj.disableFields = false;
			// }

			mainObj.isDuplicate = false;
			let match = _.find(this.model.selectedDenomination, (compairObject, compairObjIndex) => {
				if (mainIndex > compairObjIndex && compairObject.denom && mainObj.denom && compairObject.denom.Value && mainObj.denom.Value) {
					return compairObject.denom.Value === mainObj.denom.Value;
				}
			});
			if (match) {
				mainObj.isDuplicate = true;
				return mainObj;
			}
			return mainObj;
		});


		let isValid = this.model.selectedDenomination.map((obj, index) => {
			if (obj.isDuplicate) return true;

		})
		this.isValidDenomination = isValid.indexOf(true) >= 0 ? false : true;
		this.validateLocationSlotsDuplicate();
		this.checkForMaxLoadFaceValueDivisibility();
	}


	ngResidualPercentage(index, type) {
		const item = this.model.selectedDenomination[index];
		if (type == 'min' && item.minResidualThresholdPercentage && !String(item.minResidualThresholdPercentage).endsWith('%')) {
			item.minResidualThreshold = item.minResidualThresholdPercentage / 100 + '%';
			return item.minResidualThresholdPercentage = item.minResidualThresholdPercentage + '%';
		}

		else if (type == 'max' && item.maxResidualThresholdPercentage && !String(item.maxResidualThresholdPercentage).endsWith('%')) {
			item.maxResidualThreshold = item.maxResidualThresholdPercentage / 100 + '%';
			return item.maxResidualThresholdPercentage = item.maxResidualThresholdPercentage + '%';
		}
	}

	removeResidualPercentageSign(index, type) {
		const item = this.model.selectedDenomination[index];
		if (type == 'min' && item.minResidualThresholdPercentage && item.minResidualThresholdPercentage.endsWith('%')) {
			item.minResidualThreshold = item.minResidualThreshold.replace('%', '');
			return item.minResidualThresholdPercentage = item.minResidualThresholdPercentage.replace('%', '');
		}

		else if (type == 'max' && item.maxResidualThresholdPercentage && item.maxResidualThresholdPercentage.endsWith('%')) {
			item.maxResidualThreshold = item.maxResidualThreshold.replace('%', '');
			return item.maxResidualThresholdPercentage = item.maxResidualThresholdPercentage.replace('%', '');
		}
	}

	validateLocationSlotsDuplicate() {
		if (!this.locationSlots || this.locationSlots.length === 0) {
			this.duplicateLocationSlotError = false;
			return true;
		}
		this.locationSlots.forEach(slot => slot.isDuplicate = false);
		let hasDuplicate = false;
		this.locationSlots.forEach((slot, index) => {
			const denomId = slot.denominationId && (slot.denominationId.id || slot.denominationId.Value || slot.denominationId);
			const trackingId = (slot.slotTrackingId || '').trim().toLowerCase();
			let match = this.locationSlots.find((other, otherIdx) => {
				if (index > otherIdx) {
					const otherDenomId = other.denominationId && (other.denominationId.id || other.denominationId.Value || other.denominationId);
					const otherTrackingId = (other.slotTrackingId || '').trim().toLowerCase();
					return denomId === otherDenomId && trackingId === otherTrackingId;
				}
				return false;
			});
			if (match) {
				slot.isDuplicate = true;
				hasDuplicate = true;
			}
		});
		this.duplicateLocationSlotError = hasDuplicate;
		return !hasDuplicate;
	}

	onFlowThresholdBlur() {
		if (this.model.balanceType === 'PERCENTAGE' && this.model.flowThreshold) {
			let val = parseFloat(this.model.flowThreshold.toString());
			if (!isNaN(val)) {
				this.model.flowThreshold = val + '%';
			}
		}
	}
	onFlowThresholdFocus() {
		if (this.model.balanceType === 'PERCENTAGE' && typeof this.model.flowThreshold === 'string') {
			this.model.flowThreshold = this.model.flowThreshold.replace('%', '');
		}
	}
	resetFlowThreshold() {
		this.model.flowThreshold = this.model.balanceType == 'PERCENTAGE' ? this.convertStr(0.2) / 100 : 0.2;
	}

	hasValidEmails(emailString, isRequired = false) {
		if (!emailString) return !isRequired;
		const emails = emailString.split(',').map(email => email.trim());
		const uniqueEmails = new Set();
		for (const email of emails) {
			if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
				return false;
			}
			if (uniqueEmails.has(email)) {
				return false;
			}
			uniqueEmails.add(email);
		}
		return true;
	}

	loadPickupRequestTimes() {
		return this.LocationService.getPickupRequestTimes()
			.then((data) => {
				if (data.status) {
					this.pickupRequestTimes = data.data;
				}
			})
			.catch((err) => {
				console.log('Error loading pickup request times:', err);
			});
	}

	onMarkerDragEnd($event) {
		this.model.latitude = $event.latLng.lat()
		this.model.longitude = $event.latLng.lng()
		if (this.model.latitude && this.model.longitude) {
			this.getAddressFromLatLng(this.model.latitude, this.model.longitude)
		}
		document.getElementById("lat").value = this.model.latitude;
		document.getElementById("lng").value = this.model.longitude;
	}
}

export default LocationCreateController;



// WEBPACK FOOTER //
// ./client/app/components/location/create/location.create.controller.js